export default {"src":"/_next/static/media/dashboard-icon.d5d36402.svg","height":16,"width":16};